<template>
  <div v-show="loading" class="loadingScreen" :style="{ backgroundImage }">
    <div class="loadingHeaderBlock">
      <div class="loadingTexts">
        <div class="loadingHeader">
          {{ $t("loadingTitle") }}
        </div>

        <div class="loadingText">
          {{ $t(`loadingText${lab}`) }}
        </div>
      </div>
      <div class="loadingLoader">
        <img class="loadingLoaderGIF" :src="loadingIcon_GIF" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "SpinnerComponent",
  data() {
    return {
      loadingIcon_GIF: require("../assets/videos/loadingGIF.gif"),
    };
  },
  computed: {
    lab() {
      return this.$store.getters.getCurrentLab;
    },
    backgroundImage() {
      return `url('${require(`../assets/images/loader/background_${this.lab}.jpg`)}')`;
    },
    loading() {
      return this.$store.getters.isSpinnerLoading;
    },
  },
};
</script>
<style lang="scss" scoped>
.loadingScreen {
  position: absolute;
  width: 100vw;
  height: 100vh;
  color: white;
  font-size: 25px;
  text-align: center;
  z-index: 8;
  opacity: 1;
  background: rgb(0, 0, 0);
  background-size: cover;
  background-position: center;
  background-color: -moz-linear-gradient(
    0deg,
    rgba(0, 0, 0, 1) 0%,
    rgba(60, 60, 60, 1) 100%
  );
  background-color: -webkit-linear-gradient(
    0deg,
    rgba(0, 0, 0, 1) 0%,
    rgba(60, 60, 60, 1) 100%
  );
  background-color: linear-gradient(
    0deg,
    rgba(0, 0, 0, 1) 0%,
    rgba(60, 60, 60, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#000000",endColorstr="#3c3c3c",GradientType=1);
  // background-image: url("../assets/images/loader/background_Indoor_Lab.png");
  // http://localhost:9000/assets/images/loader/background_Indoor_Lab.png
  // http://localhost:9000/img/background_Indoor_Lab.6d3ea283.png
  .loadingHeaderBlock {
    height: calc(100vh - 200px);
    width: calc(100vw - 200px);
    margin: 100px;
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    flex-direction: column;
    align-items: center;

    @media (max-width: 768px) {
      margin: 25px;
      height: calc(100vh - 50px);
      width: calc(100vw - 50px);
    }

    .loadingTexts {
      .loadingHeader {
        font-family: Unna;
        font-size: 60px;
        color: white;
        text-align: center;
        line-height: 100%;
      }

      .loadingText {
        font-family: Calibre;
        font-size: 20px;
        color: white;
        text-align: center;
        line-height: 30px;
        margin-top: 30px;
        max-width: 1300px;
      }
    }

    .loadingLoader {
      flex: 1;
      display: flex;
      align-items: center;

      .loadingLoaderGIF {
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;

        min-width: 200px;
        width: 15vw;
        max-width: 300px;

        min-height: 200px;
        height: 15vw;
        max-height: 300px;
      }
    }

    .loadingMap {
      margin-bottom: 2%;
      width: 16%;
    }
  }
}
</style>
